export function buildCreateTradeFormEventRequestBody(status, data, loggedInUserData) {
  let tradeFormEventRequestBody = {
    action: "addTradeFormEvent",
    tradeStatus: status,
    modifiedByEid: loggedInUserData.eid,
    modifiedByFirstName: loggedInUserData.firstName,
    modifiedByLastName: loggedInUserData.lastName,
    station: data.station,
    workgroup: data.workgroup,
    isSupervisorInvolved: data.isSupervisorInvolved,
    tradeFormType: data.tradeFormType,
    offeredEmployeeId: data.offeredEmployeeId,
    offeredEmployeeFirstName: data.offeredEmployeeFirstName,
    offeredEmployeeLastName: data.offeredEmployeeLastName,
    offeredEmployeeWorkgroup: data.offeredEmployeeWorkgroup,
    offeredShiftStart: data.offeredShiftStart,
    offeredShiftStartHour:
      data.offeredShiftStartHour || data.offeredShiftStartHour === 0
        ? data.offeredShiftStartHour
        : data.offeredShiftStart.hour, // If no shiftHour is supplied we can assume the offeredShiftStart field is a Luxon DateTime
    offeredShiftStartMinute:
      data.offeredShiftStartMinute || data.offeredShiftStartMinute === 0
        ? data.offeredShiftStartMinute
        : data.offeredShiftStart.minute,
    offeredShiftEnd: data.offeredShiftEnd,
    offeredShiftEndHour:
      data.offeredShiftEndHour || data.offeredShiftEndHour === 0
        ? data.offeredShiftEndHour
        : data.offeredShiftEnd.hour,
    offeredShiftEndMinute:
      data.offeredShiftEndMinute || data.offeredShiftEndMinute === 0
        ? data.offeredShiftEndMinute
        : data.offeredShiftEnd.minute,
    isOfferedReliefShift: data.isOfferedReliefShift,
    requestedEmployeeId: data.requestedEmployeeId,
    requestedEmployeeFirstName: data.requestedEmployeeFirstName,
    requestedEmployeeLastName: data.requestedEmployeeLastName,
    requestedEmployeeWorkgroup: data.requestedEmployeeWorkgroup,
    requestedShiftStart: data.requestedShiftStart,
    requestedShiftStartHour:
      data.requestedShiftStartHour || data.requestedShiftStartHour === 0
        ? data.requestedShiftStartHour
        : data.requestedShiftStart
        ? data.requestedShiftStart.hour
        : null,
    requestedShiftStartMinute:
      data.requestedShiftStartMinute || data.requestedShiftStartMinute === 0
        ? data.requestedShiftStartMinute
        : data.requestedShiftStart
        ? data.requestedShiftStart.minute
        : null,
    requestedShiftEnd: data.requestedShiftEnd,
    requestedShiftEndHour:
      data.requestedShiftEndHour || data.requestedShiftEndHour === 0
        ? data.requestedShiftEndHour
        : data.requestedShiftEnd
        ? data.requestedShiftEnd.hour
        : null,
    requestedShiftEndMinute:
      data.requestedShiftEndMinute || data.requestedShiftEndMinute === 0
        ? data.requestedShiftEndMinute
        : data.requestedShiftEnd
        ? data.requestedShiftEnd.minute
        : null,
    isRequestedReliefShift: data.isRequestedReliefShift,
    cannedReason: data.cannedReason ? data.cannedReason : "",
    reasonComments: data.reasonComments ? data.reasonComments : "",
    flags: {
      isAdditionalApproved: data.isAdditionalApproved ? data.isAdditionalApproved : false,
      isReinstated: data.isReinstated ? data.isReinstated : false,
      isAdminCreated: data.isAdminCreated ? data.isAdminCreated : false,
    },
  };
  
  if (data.tradeFormId) {
    // An existing trade has a new event
    // Make sure to add critical id's that will tie this event to the trade
    tradeFormEventRequestBody.tradeFormId = data.tradeFormId;
    tradeFormEventRequestBody.referenceNumber = data.referenceNumber;
  }

  return tradeFormEventRequestBody;
}
